import { PageView, RouteView } from '@/layouts'
//设置部分
export const settingRouter = [
  {
    path: '/settings',
    name: 'settings',
    redirect: '/settings/account/securitySetting',
    component: RouteView,
    meta: { title: '设置', keepAlive: true, icon: 'setting' },
    children: [
      {
        path: '/settings/account',
        redirect: '/settings/account/securitySetting',
        component: RouteView,
        meta: { title: '账号设置', keepAlive: true, icon: 'setting'},
        children: [
          {
            path: '/settings/account/securitySetting',
            name: 'SecuritySetting',
            component: () => import('@/views/settings/SecuritySetting'),
            meta: { title: '安全设置', keepAlive: false, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            path: '/settings/account/basicSettings',
            name: 'BasicSettings',
            ignorePermissions: true,
            component: () => import('@/views/settings/BasicSettings'),
            meta: { title: '基本设置', keepAlive: false, ignorePermissions: true  }
          },
          {
            path: '/settings/all/permission',
            name: 'AllPermission',
            meta: { title: '所有权限设置', keepAlive: false, hidePermissionTree: true },
            component: () => import('@/views/settings/AllPermission.vue'),
          },
          {
            path: '/settings/account/subAccount',
            name: 'SubAccount',
            component: () => import('@/views/settings/SubAccount'),
            meta: {
              title: '子账号管理',
              keepAlive: true ,
              actions: [
                { key: 'add', permissionId: 'RoleCreator' },
                { key: 'edit', permissionId: 'RoleEditor' },
                { key: 'delete', permissionId: 'RoleDelete' },
              ],
            }
          },
          {
            hidden: true,
            path: '/settings/role/roleCreator',
            name: 'RoleCreator',
            superName: 'SubAccount',//上级的名称
            component: () => import('@/views/settings/RoleEditor2'),
            meta: { title: '创建角色', keepAlive: true ,hidePermissionTree: true,hideInMenu: true, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/settings/role/roleEditor',
            name: 'RoleEditor',
            superName: 'SubAccount',//上级的名称
            component: () => import('@/views/settings/RoleEditor2'),
            meta: { title: '编辑角色', keepAlive: true  ,hidePermissionTree: true,hideInMenu: true, ignorePermissions: true},
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/settings/account/materialSpace',
            name: 'MaterialSpace',
            component: () => import('@/views/settings/MaterialSpace'),
            meta: { title: '素材空间', keepAlive: true, hideInMenu: true }
          },
          {
            path: '/settings/account/downloadTable',
            name: 'DownloadTable',
            component: () => import('@/views/settings/DownloadTable'),
            meta: { title: '报表下载中心', keepAlive: false, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            path: '/settings/account/PaySetting',
            name: 'PaySetting',
            component: () => import('@/views/settings/PaySetting'),
            meta: { title: '支付设置', keepAlive: false }
          },
          {
            hidden: true,
            path: '/settings/account/WxPaySetting',
            name: 'WxPaySetting',
            superName: 'PaySetting',//上级的名称
            component: () => import('@/views/settings/WxPaySetting'),
            meta: { title: '微信支付', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,
            path: '/settings/account/ZfbPaySetting',
            name: 'ZfbPaySetting',
            superName: 'PaySetting',//上级的名称
            component: () => import('@/views/settings/ZfbPaySetting'),
            meta: { title: '支付宝支付', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,
            path: '/settings/account/LargeAmountMoneyPaySetting',
            name: 'LargeAmountMoneyPaySetting',
            superName: 'PaySetting',//上级的名称
            component: () => import('@/views/settings/LargeAmountMoneyPaySetting'),
            meta: { title: '大额转账', keepAlive: false, hideInMenu: true }
          },
          {
            hidden: true,
            path: '/settings/account/BalancePaySetting',
            name: 'BalancePaySetting',
            superName: 'PaySetting',//上级的名称
            component: () => import('@/views/settings/BalancePaySetting'),
            meta: { title: '余额支付', keepAlive: false, hideInMenu: true }
          },
          {
            path: '/settings/account/VersionDescription',
            name: 'VersionDescription',
            component: () => import('@/views/settings/VersionDescription'),
            meta: { title: '版本说明', keepAlive: false,hideInMenu: true, hidePermissionTree: true }
          }
        ]
      }
    ]
  }
]

